import { useSyncExternalStore } from 'react';

export type SubsidiaryYearHighlight = {
  rcid: number;
  from: string;
  to: string;
  ids: string[];
  leftIds: string[];
};

let current: SubsidiaryYearHighlight | null = null;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setSubsidiaryYearHighlight = (
  next: SubsidiaryYearHighlight | null
): void => {
  if (
    current?.rcid === next?.rcid &&
    current?.from === next?.from &&
    current?.to === next?.to
  ) {
    return;
  }
  current = next;
  for (const listener of listeners) listener();
};

export const useSubsidiaryYearHighlight = (
  rcid: number | null
): SubsidiaryYearHighlight | null =>
  useSyncExternalStore(subscribe, () =>
    current !== null && current.rcid === rcid ? current : null
  );
